import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import {startLoadingSpinner, stopLoadingSpinner} from "../../csf-ufc-pivotal/includes/utils";
import {resetErrMessages, removeErrFromValidItems, updateHeadingBasedOnUrl} from '../includes/utils';
import JustValidate from 'just-validate';
import CsfFournisseurRecognitionRenewalTitle
  from "../includes/csf-fournisseur-recognition-renewal-title";
import moment from "moment/moment";

export function FournisseurRecognitionRequestStepSixBlock({
                                                            hasPreviousRenewalEndDate,
                                                            currentStep,
                                                            onStepChange,
                                                            accessToken,
                                                            apiUrl,
                                                            apiEnv,
                                                            user,
                                                            form,
                                                            updateForm,contact
                                                          }) {

  const language = document.documentElement.lang;
  const [validator, setValidator] = useState(null);
  const currentDate = new Date();
  const formattedCurrentDate = currentDate
    ? language === 'en'
      ? moment(currentDate).locale('en-GB').format('MMMM Do, YYYY')
      : moment(currentDate).locale(language === 'en' ? 'en-GB' : 'fr').format('Do MMMM YYYY')
    : '';

  const defaultValue = {
    'Signed': false,
  }
  const [form6Data, setForm6Data] = useState(defaultValue);

  const errorMessages = {
    '#Signed': window.Drupal.t('fournisseur.creation_form.validation.required'),
  };

  const urlParams = new URLSearchParams(window.location.search);
  const isRenewal = (urlParams.get('renewal') === 'true' || hasPreviousRenewalEndDate);

  useEffect(() => {
    const validator = new JustValidate('#form-step06');
    setValidator(validator);

    validator.addField('#Signed', [
      {
        rule: 'required',
      },
    ])
  }, []);

  function handleNextStepClick() {
    onStepChange(currentStep + 1); // Call the callback function with new count
  }

  function handlePreviousStepClick() {
    let nb = 1;
    if (form.REDU_Activity_Type_Id === "AAAAAAAAAAE=") {
      nb = 3;
    }
    onStepChange(currentStep - nb); // Call the callback function with new count
  }

  function goToSpecificStep(step) {
    onStepChange(step); // Call the callback function with new count
  }

  /*
  * Method that handle the on change values
  * */
  function handleOnChangeValues(event) {
    let eventValue = event.target.value;
    if (event.target.type === 'checkbox') {
      eventValue = event.target.checked;
    }
    setForm6Data({...form6Data, [event.target.name]: eventValue});
  }


  function submitStep6(event) {
    event.preventDefault();

    validator.revalidate();
    setTimeout(() => {
      resetErrMessages();
      if (validator?.isValid) {  // Check if form is valid
        const requestData = {
          form: 'CSF_EP_UXRecognition_6_REST',
          recordId: form?.REDU_Activity_Id,
          deltaData: form6Data
        };
        startLoadingSpinner();
        const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
        pivotalFormApi.callFormPutEndpoint(requestData, '_Espace_Partenaire')
          .then(response => {
            if (response?.success && response?.payload != null) {
              stopLoadingSpinner();
              updateForm();
              handleNextStepClick();
            }
          })
          .catch(error => {
            stopLoadingSpinner();
            console.error(error);
          });
      } else {
        console.error('Form validation failed!');
        validator.showErrors(errorMessages);
        removeErrFromValidItems();
      }
    })
  }


  // Change page title H1 if renewal
  useEffect(() => {
    updateHeadingBasedOnUrl("step6", "renewal", window.Drupal.t('fournisseur.creation_form.page.title'), window.Drupal.t('fournisseur.creation_form.page.renew.title'), hasPreviousRenewalEndDate);
  }, [hasPreviousRenewalEndDate]);

  return (
    <main className="fournisseur recognition">

      <h1 id="step6">{window.Drupal.t('fournisseur.creation_form.page.title')}</h1>

      <CsfFournisseurRecognitionRenewalTitle
        isRenewal={isRenewal || hasPreviousRenewalEndDate}
        formData={form}/>

      <div className="content">

        <aside className="form-steps-legend">
          <ol>
            <li className="completed">
              <button className="form-steps-legend-button btn-link" onClick={() => goToSpecificStep(1)}>
                <span>{window.Drupal.t('fournisseur.creation_form.steps.step1')}</span></button>
            </li>
            <li className="completed">
              <button className="form-steps-legend-button btn-link" onClick={() => goToSpecificStep(2)}>
                <span>{window.Drupal.t('fournisseur.creation_form.steps.step2')}</span></button>
            </li>
            <li className="completed">
              <button className="form-steps-legend-button btn-link" onClick={() => goToSpecificStep(3)}>
                <span>{window.Drupal.t('fournisseur.creation_form.steps.step3')}</span></button>
            </li>
            <li className="completed">
              <button className="form-steps-legend-button btn-link" onClick={() => goToSpecificStep(4)}>
                <span>{window.Drupal.t('fournisseur.creation_form.steps.step4')}</span></button>
            </li>
            <li
              className={`completed ${form.REDU_Activity_Type_Id === "AAAAAAAAAAE=" ? 'disabled' : ''}`}>
              <button
                disabled={
                  form.REDU_Activity_Type_Id === "AAAAAAAAAAE="
                }
                className="form-steps-legend-button btn-link" onClick={() => handlePreviousStepClick()}>
                <span>{window.Drupal.t('fournisseur.creation_form.steps.step5')}</span></button>
            </li>
            <li className="active"><span>{window.Drupal.t('fournisseur.creation_form.steps.step6')}</span></li>
          </ol>
        </aside>

        <div className="form-steps-content">
          <form onSubmit={submitStep6} id="form-step06">
            <fieldset>
              <legend className="visually-hidden">{window.Drupal.t('fournisseur.creation_form.page.title')}</legend>

              {language === 'fr' ? (

                <div className="form-wysiwyg">

                  <span>Je, soussigné(e), {user.First_Name} {user.Last_Name} au nom
                    de {user.Primary_Company__Rn_Descriptor},</span>

                  {(form.Submitted_To_Financial_Instit === true) ? (
                    <p>En date du {formattedCurrentDate}, identifié à l'Institut sous le
                      matricule {contact.IPF_Matricule_Bridge ? `${contact.IPF_Matricule_Bridge} :` : "identifié dans le formulaire."}</p>
                  ) : (<span> : </span>)}
                  <ul>

                    {form.Submitted_To_Financial_Instit === true && (
                      <li>
                        comprends que les renseignements en lien avec cette demande seront communiqués à l’Institut de
                        planification financière dans le cas où j’en ai fait la demande, et qu’ils seront traités
                        conformément aux Règles encadrant la gouvernance à l’égard des renseignements personnels de la
                        CSF.
                      </li>
                    )}

                    <li>confirme que tous les renseignements fournis dans cette demande de reconnaissance et documents
                      joints sont véridiques et accepte toutes les conditions relatives à la reconnaissance d’une
                      formation.
                    </li>
                    <li>confirme que tous les renseignements et documents soumis reflètent l'ensemble des changements
                      depuis la dernière demande, s'il y a lieu.
                    </li>
                    <li>comprends qu'à défaut de recevoir toute information ou document manquant qu'elle aura exigé dans
                      les quinze (15) jours ouvrables souvants la réception de la présente demande de reconnaissance, la
                      Chambre de la sécurité financière (« La Chambre ») ou l'Institut de planification financière («
                      l'Institut ») annulera cette demande, et ce, sans remboursement des frais de base.
                    </li>
                    <li>
                      m'engage à ce que toutes les règles et politiques applicables concernant la reconnaissance des
                      activités de formation continue de La Chambre ou de L'Institut soient respectées.
                    </li>
                    <li>
                      confirme que cette demande ou cette formation peut faire l'objet d'un audit de la part de La
                      Chambre ou de L'Institut.
                    </li>


                    {form.Condition_With_Trainer === true ? (
                      <>
                        <li>
                          confirme que le(s) formateur(s) choisi(s) pour diffuser la formation faisant l’objet de cette
                          demande
                          de
                          reconnaissance possède(nt) :
                          <ul>
                            <li>Les connaissances;</li>
                            <li>L’expérience requise;</li>
                            <li>La capacité de transmettre son(leur) savoir;</li>
                          </ul>

                        </li>
                        <li>comprends qu’il est de ma responsabilité de m’assurer que les documents des formateurs ont
                          été
                          mis à jour il y a moins de deux (2) ans et permettent de vérifier l’adéquation entre leurs
                          profils
                          et l’activité de formation soumise;
                        </li>
                        <li>comprends que l’activité de formation nécessitant un formateur pourra être
                          dispensée
                          et donnera lieu à des UFC pour les participants, seulement lorsqu'un formateur possédant les
                          connaissances l’expérience requises et la capacité de transmettre son savoir
                          sera autorisé;
                        </li>
                      </>
                    ) : <>
                      <li>
                        confirme qu'aucun formateur n'a été déterminé au moment de cette demande et je comprends que la
                        reconnaissance de cette formation sera octroyée uniquement lorsque La Chambre ou L'Institut aura
                        reçu les informations concernant ce ou ces formateur(s) et qu'elle jugera qu'il a été démontré
                        que le ou les formateur(s) possède(nt) les connaissances, l'expérience requise et la capacité de
                        transmettre son (leur) savoir.
                      </li>

                    </>}
                    {form.Condition_With_Evaluation === true && (
                      <li>confirme que le niveau de difficulté des questions de l'évaluation sommative est
                        suffisamment
                        élevé, permettant ainsi d’établir si l’apprenant a suivi la totalité de la formation ; et que
                        la
                        note de passage est supérieure ou égale à soixante (60)%;
                      </li>
                    )}
                  </ul>

                  <div className="form-group d-flex align-items-center flex-wrap">
                    <input onChange={handleOnChangeValues} value={form6Data['Signed']} type="checkbox"
                           id="Signed" name="Signed"/>

                    <label htmlFor="Signed">Je comprends que cocher cette case constitue une signature ayant
                      force
                      légale*</label>
                  </div>

                </div>
              ) : (
                <div className="form-wysiwyg">
                  <span>I, the undersigned, {user.Last_Name}, {user.First_Name} confirm on behalf
                      of {user.Primary_Company__Rn_Descriptor}:</span>

                  {(form.Submitted_To_Financial_Instit === true) ? (
                    <p>As of {formattedCurrentDate}, identified to the Institute under the
                      matricule {contact.IPF_Matricule_Bridge ?  `${contact.IPF_Matricule_Bridge}:` : "identified in the form."}</p>
                  ) : (<span> : </span>)}
                  <ul>
                    {form.Submitted_To_Financial_Instit === true && (
                      <li>
                        understands that the information regarding this application will be transmitted only if a
                        request was made to the Institut de planification financière, and
                        that they will be treated in accordance with the Rules governing personal information of the
                        CSF.
                      </li>
                    )}

                    <li>confirm that all the information provided in this recognition application and attached
                      documents
                      are true and accept all the conditions related to the recognition of a training.
                    </li>
                    <li>confirm that all information and documents submitted reflect all changes since the last
                      application, if applicable;
                    </li>
                    <li>understand that if any missing information or document fail to be provided within the required
                      fifteen (15) working days following receipt of this application for recognition, the CSF or the
                      Institute will cancel this request, without refund of the basic fees;
                    </li>
                    <li>
                      commit to ensure that the CSF's Policy on Compulsatory Professional Development Activities or
                      the Professional Development Activity Recognition Procedure - Suppliers are respected.
                    </li>
                    <li>
                      understand that this application or training may be subject to an audit by the CSF or the
                      Institute;
                    </li>


                    {form.Condition_With_Trainer === true ? (
                      <>
                        <li>
                          that the trainer(s) chosen to deliver the training subject to this recognition application
                          possess(es):
                          <ul>
                            <li>The knowledge;</li>
                            <li>The required experience;</li>
                            <li>The ability to convey their knowledge;</li>
                          </ul>

                        </li>
                        <li>understand that it is my responsibility to ensure that the trainers' documents have been
                          updated
                          within the last two (2) years and allow verification of the adequacy between their profiles
                          and
                          the training activity submitted;
                        </li>
                        <li>understand that the training activity requiring a trainer cannot be provided and will
                          therefore
                          not give assign PDUs for the participants as long as a trainer with the required knowledge,
                          experience and the ability to convey their knowledge is not associated with the training;
                        </li>
                      </>
                    ) : <>
                      <li>
                        confirms that no trainer has yet been identified at this moment and I understand the
                        accreditation for this training will only be granted once the Chambre and Institute will receive
                        all information on one or more trainers with adequate training, knowledge and experience needed
                        in order to transmit their expertise.
                      </li>

                    </>}
                    {form.Condition_With_Evaluation === true && (
                      <li>confirms that the level of difficulty of the summative evaluation questions is sufficiently
                        high, thus allowing to establish whether the learner has completed the entire training; and that
                        the passing grade is greater than or equal to sixty (60)%;
                      </li>
                    )}
                  </ul>

                  <div className="form-group d-flex align-items-center flex-wrap">
                    <input onChange={handleOnChangeValues} value={form6Data['Signed']} type="checkbox"
                           id="Signed" name="Signed"/>

                    <label htmlFor="Signed">I understand that checking this box constitutes a legally binding
                      signature*</label>
                  </div>

                </div>

              )}
              <div className="row action-buttons">
                <div className="col text-center">
                  <button className="button btn-outlined btn-larger" type="button" onClick={() => handlePreviousStepClick()}>
                    {window.Drupal.t('fournisseur.previous.btn')}
                  </button>
                </div>
                <div className="col text-center">
                  <button className="button btn-larger" type="button" onClick={submitStep6}>
                    {window.Drupal.t('fournisseur.creation_form.form.submit')}
                  </button>
                </div>
              </div>

            </fieldset>
          </form>
        </div>
      </div>

    </main>
  );
}

FournisseurRecognitionRequestStepSixBlock.propTypes = {
  hasPreviousRenewalEndDate: PropTypes.bool,
  currentStep: PropTypes.number.isRequired,
  onStepChange: PropTypes.func,
  accessToken: PropTypes.string.isRequired,
  apiUrl: PropTypes.string.isRequired,
  apiEnv: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  form: PropTypes.object.isRequired,
  updateForm: PropTypes.func.isRequired,
  contact: PropTypes.object.isRequired
}
